import { assert } from 'ts-essentials';
import { call, put, select, takeLeading } from 'typed-redux-saga';
import { StreamService } from '../../../services/stream';
import { createStreamUser } from '../../../utils/stream';
import { type RootState } from '../../root.state';
import { streamSlice } from '../../stream/stream.slice';
import { getContainer } from '../../utils.saga';
import { connectPrayerStreamUserSlice } from './connect-prayer-stream-user.slice';

export function* connectPrayerStreamUserSaga(): Generator {
  const container = yield* getContainer();
  const streamService = container.get(StreamService);

  yield* put(
    connectPrayerStreamUserSlice.actions.connectPrayerStreamUserStarted(),
  );

  const { contactUid, name } = yield* select((state: RootState) => state.auth);
  const { prayerStreamUserToken } = yield* select(
    (state: RootState) => state.stream,
  );
  assert(contactUid, 'streamSaga: contactUid');
  assert(name, 'streamSaga: name');
  assert(prayerStreamUserToken, 'streamSaga: prayerStreamUserToken');

  const user = createStreamUser(contactUid, name);

  try {
    if (!streamService.isConnected) {
      yield* call(async () => {
        await streamService.connectUser(user, prayerStreamUserToken);
      });
      yield* put(streamSlice.actions.setConnected());
      yield* put(
        connectPrayerStreamUserSlice.actions.connectPrayerStreamUserSucceeded(),
      );
    }
  } catch {
    throw new Error('Unable to connect to streamService');
  }
}

export function* watchConnectPrayerStreamUserRequestsSaga(): Generator {
  yield* takeLeading(
    connectPrayerStreamUserSlice.actions.connectPrayerStreamUserRequested,
    function* lambda(action) {
      yield* call(connectPrayerStreamUserSaga, action.payload);
    },
  );
}
